module.exports = __webpack_public_path__ + "static/media/ug.6d6f8896.svg";